module.exports = __webpack_public_path__ + "static/img/39.1167fc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/39.png
// module id = xYeo
// module chunks = 0